import * as tus from 'tus-js-client';
import { API_BASE_URL } from './api';

const TUS_ENDPOINT = `${API_BASE_URL}/tus/upload`;
const CHUNK_SIZE = 5 * 1024 * 1024;

/**
 * Upload resumível via Tus (browser).
 * @returns {Promise<{ uploadUrl: string, s3Key: string, uploadId: string, upload: object }>}
 */
export function uploadFileWithTus(file, options = {}) {
  const { jobId, token, onProgress, onUploadCreated, previousUploadUrl } = options;

  return new Promise((resolve, reject) => {
    const tokenValue = token || localStorage.getItem('access_token');
    if (!tokenValue) {
      reject(new Error('Sessão expirada. Faça login novamente.'));
      return;
    }

    const upload = new tus.Upload(file, {
      endpoint: TUS_ENDPOINT,
      uploadUrl: previousUploadUrl || undefined,
      retryDelays: [0, 1000, 3000, 5000],
      chunkSize: CHUNK_SIZE,
      headers: {
        Authorization: `Bearer ${tokenValue}`,
      },
      metadata: {
        filename: file.name,
        filetype: file.type || 'application/octet-stream',
        job_id: jobId,
        folder: 'deliveries',
      },
      onError: (error) => reject(error),
      onProgress: (bytesUploaded, bytesTotal) => {
        if (onProgress) onProgress(bytesUploaded, bytesTotal);
      },
      onUploadUrlAvailable: (uploadUrl) => {
        if (onUploadCreated) onUploadCreated(uploadUrl, upload);
      },
      onSuccess: async () => {
        try {
          const uploadUrl = upload.url;
          const uploadId = uploadUrl ? uploadUrl.split('/').pop() : null;
          if (!uploadId) {
            reject(new Error('Upload concluído sem ID.'));
            return;
          }
          const statusRes = await fetch(`${TUS_ENDPOINT}/${uploadId}/status`, {
            headers: { Authorization: `Bearer ${tokenValue}` },
          });
          if (!statusRes.ok) {
            reject(new Error('Não foi possível confirmar o upload no servidor.'));
            return;
          }
          const statusData = await statusRes.json();
          if (statusData.status !== 'completed' || !statusData.s3_key) {
            reject(
              new Error(
                'Upload concluído mas informações S3 indisponíveis. Aguarde e tente confirmar novamente.'
              )
            );
            return;
          }
          resolve({
            uploadUrl: statusData.s3_url,
            s3Key: statusData.s3_key,
            uploadId,
            upload,
          });
        } catch (e) {
          reject(e);
        }
      },
    });

    upload.start();
  });
}

export function abortTusUpload(uploadInstance) {
  if (uploadInstance && typeof uploadInstance.abort === 'function') {
    uploadInstance.abort(true);
  }
}
